import type { ImplementedCopilotFeatures, CopilotSettingsStore } from 'owa-copilot-settings-store';
import { getApplicationSettings } from 'owa-application-settings';
import isCopilotFeatureEnabled from './isCopilotFeatureEnabled';
import createStoreCheckForGenericEnablement from './createStoreCheckForGenericEnablement';
import type { MailboxInfo } from 'owa-client-types';
import { isFeatureEnabled } from 'owa-feature-flags';

type EligibleScenarios = Extract<ImplementedCopilotFeatures, 'Elaborate'>;

const isSydneyCapabilityPresent = (): ((
    scenario: EligibleScenarios,
    mailboxInfo: MailboxInfo,
    skipLanguageCheck?: boolean,
    shouldIgnoreUserPreferences?: boolean
) => boolean | undefined) =>
    createStoreCheckForGenericEnablement<EligibleScenarios, boolean>(
        'SydneyCapabilityPresent',
        isSydneyCapabilityPresentInternal
    );

export default isSydneyCapabilityPresent;

function isSydneyCapabilityPresentInternal(
    store: CopilotSettingsStore,
    _language: string,
    scenario: EligibleScenarios,
    mailboxInfo: MailboxInfo,
    skipLanguageCheck?: boolean
): boolean {
    if (store.isEnabled) {
        const featureEnabled = store.featureInfo.get(scenario);
        if (featureEnabled?.isEnabled) {
            const appSettings = getApplicationSettings('Copilot', mailboxInfo);
            return (
                !isFeatureEnabled('mon-copilot-sydney-disable') &&
                !!isCopilotFeatureEnabled(
                    scenario,
                    mailboxInfo,
                    skipLanguageCheck ?? appSettings.enableMultiLanguage
                ) &&
                !!featureEnabled.capabilities &&
                'sydneyCapable' in featureEnabled.capabilities &&
                featureEnabled.capabilities.sydneyCapable
            );
        }
    }
    return false;
}
